/**
 * Count style depends on detail_size
 * @param {number} str - size
 */
export const detailSize = (size) => {
  switch (size) {
    case 1:
      return 'is-one-quarter-widescreen is-one-third-desktop is-half-tablet'
    case 2:
      return 'is-half-widescreen is-two-thirds-desktop is-full-tablet'
    case 3:
      return 'is-three-quarters-widescreen is-full-desktop is-full-tablet'
    case 4:
      return 'is-full'

    default:
      return 'is-one-quarter'
  }
}

/**
 * Count style depends on element position
 * @param {toolTip} object - data of current element
 * @param {parentSelector} string - parent element
 */
export const handleToolTipMouseEnter = (toolTip, parentSelector) => {
  const parent = toolTip.target.closest(parentSelector)
  if (parent) {
    const parentStasticts = parent.getBoundingClientRect()
    const parentRightX = parentStasticts.x + parentStasticts.width

    const tooltipElement = toolTip.target.classList.value.includes('lox-tooltip-moveable')
      ? toolTip.target
      : toolTip.target.closest('.lox-tooltip-moveable')

    const rect = tooltipElement.getBoundingClientRect();

    //This will only use for tooltip use handleToolTipMouseEnter
    tooltipElement.classList.add('has-tooltip-fixed');
    tooltipElement.classList.add('has-tooltip-fixed-dropdown-menu');

    //Convert tooltip to fixed position to allow to show tooltip inside overflow hidden
    tooltipElement.style.setProperty('--before-left', `${rect.left}px`);
    tooltipElement.style.setProperty('--before-top', `${rect.top + 24}px`);
    tooltipElement.style.setProperty('--before-transform', `translate(-50%, 0)`);

    tooltipElement.classList.remove('right', 'left')
    if (toolTip.clientX < 150) {
      tooltipElement.classList.add('right')
      tooltipElement.style.setProperty('--before-transform', `translate(-5%, 0)`);
    } else if (parentRightX - toolTip.clientX < 150) {
      tooltipElement.classList.add('left')
      tooltipElement.style.setProperty('--before-transform', `translate(-80%, 0)`);
    }
    const thFixed = toolTip.target.closest('th.fixed.sticky')
    if (thFixed) {
      thFixed.classList.remove('fixed')
      thFixed.classList.remove('sticky')
      thFixed.classList.add('fixed-sticky')
    }
  }
}
